import './TrendFilters.scss'
import React from 'react'
import { observer } from 'mobx-react'
import { trendStore } from '../stores'
import { SelectInput } from '../lib'
import { denominations, regions, attendance } from '../assess/question'

const DenominationFilter = ({ value, onChange }) => {
  return (
    <SelectInput value={value} onChange={onChange}>
      <option value={0}>all</option>
      {denominations.map(denomination => (
        <option value={denomination.value} key={denomination.value}>
          {denomination.label}
        </option>
      ))}
    </SelectInput>
  )
}

const RegionFilter = ({ value, onChange }) => {
  return (
    <SelectInput value={value} onChange={onChange}>
      <option value='00'>worldwide</option>
      <optgroup label='United States'>
        {regions.map(region => (
          <option value={region.value} key={region.value}>
            in {region.label}
          </option>
        ))}
      </optgroup>
    </SelectInput>
  )
}

const AttendanceFilter = ({ value, onChange }) => {
  return (
    <SelectInput value={value} onChange={onChange}>
      <option value='00'>any number</option>
      {attendance.map(attend => (
        <option value={attend.value} key={attend.value}>
          {attend.label}
        </option>
      ))}
    </SelectInput>
  )
}

const TrendFilters = () => {
  return (
    <div className='TrendFilters'>
      <div className='TrendFilter'>
        <h5>Denomination</h5>
        <DenominationFilter
          value={trendStore.filter.denomination}
          onChange={denomination => trendStore.setFilter('denomination', denomination)}
        />
      </div>
      <div className='TrendFilter'>
        <h5>Location</h5>
        {/* <br /> */}
        <RegionFilter
          value={trendStore.filter.region}
          onChange={region => trendStore.setFilter('region', region)}
        />
      </div>
      <div className='TrendFilter'>
        <h5>Attendance</h5>
        <AttendanceFilter
          value={trendStore.filter.attendance}
          onChange={attendance => trendStore.setFilter('attendance', attendance)}
        />
      </div>
    </div>
  )
}

TrendFilters.displayName = 'TrendFilters'

export default observer(TrendFilters)



// WEBPACK FOOTER //
// ./src/home/TrendFilters.js